// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const goat = defineModel({
  id: "goat",
  scale: 2.18, // real-world size correction (see Model.scale)
  batchId: "future",
  name: "Goat",
  tags: ["creature","goat","low-poly","age-of-mcp","future"],
  summary: "A hardy goat — milk, meat and hide; browses rough ground.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.1,
  fits: ["draft"],
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.008, 0.006, 0.07, 5), color: "#6b6b6b", position: [0.05, 0.035, 0.03] },
      { geometry: new THREE.CylinderGeometry(0.008, 0.006, 0.07, 5), color: "#6b6b6b", position: [0.05, 0.035, -0.03] },
      { geometry: new THREE.CylinderGeometry(0.008, 0.006, 0.07, 5), color: "#6b6b6b", position: [-0.05, 0.035, 0.03] },
      { geometry: new THREE.CylinderGeometry(0.008, 0.006, 0.07, 5), color: "#6b6b6b", position: [-0.05, 0.035, -0.03] },
      { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#cfcabd", position: [0, 0.1, 0], scale: [1.6, 1, 0.9] },
      { geometry: new THREE.IcosahedronGeometry(0.024, 0), color: "#dad6cb", position: [0.062, 0.105, 0], scale: [1.2, 0.9, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.026, 0), color: "#dad6cb", position: [0.082, 0.135, 0], scale: [1.3, 0.95, 0.9] },
      { geometry: new THREE.BoxGeometry(0.026, 0.016, 0.022), color: "#dad6cb", position: [0.104, 0.128, 0] },
      { geometry: new THREE.ConeGeometry(0.008, 0.034, 5), color: "#9a8f7a", position: [0.08, 0.152, 0.013], rotation: [0.2, 0, 0.9] },
      { geometry: new THREE.ConeGeometry(0.008, 0.034, 5), color: "#9a8f7a", position: [0.08, 0.152, -0.013], rotation: [-0.2, 0, 0.9] },
      { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#cfcabd", position: [0.07, 0.142, 0.026], scale: [0.7, 0.5, 1.3] },
      { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#cfcabd", position: [0.07, 0.142, -0.026], scale: [0.7, 0.5, 1.3] },
      { geometry: new THREE.ConeGeometry(0.01, 0.026, 4), color: "#b8b2a4", position: [0.1, 0.108, 0], rotation: [0, 0, 3.141593] },
      { geometry: new THREE.ConeGeometry(0.012, 0.024, 4), color: "#cfcabd", position: [-0.078, 0.115, 0], rotation: [0, 0, 1.2] },
    ],
  animations: [],
});
